// The Draft Workspace's chat rail: which session it may reuse and what it tells
// the server is open. Pure, so the rules are unit-testable without the editor.
import type { ActiveRecord } from "../../data/chatQuery";

/** The workspace chat is the assistant persona scoped to the draft (the backend
 *  resolves it from activeDraftId; the stored kind just has to agree). */
export const WORKSPACE_CHAT_KIND = "assistant" as const;

/** A restored session (?chat=) is reusable only if it was opened FROM this draft;
 *  a Home chat, or another draft's chat, must not be adopted. */
export function isWorkspaceSessionFor(
  session: { activeDraftId?: string | null } | undefined,
  draftId: string
): boolean {
  return session?.activeDraftId === draftId;
}

/** Sent on every turn so the server's open record is explicit, not inferred. */
export function workspaceOpenRecord(draftId: string): ActiveRecord {
  return { type: "draft", id: draftId };
}
